<template>
  <main class="error">
    <div class="error__content">404</div>
    <div class="error__link"><router-link to="/">Back to home</router-link></div>
  </main>
</template>

<script>
export default {
  mounted () {
    this.$nextTick(() => { this.$parent.video = false })
  }
}
</script>

<style lang="scss" scoped>
.error
{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex-direction: column;

  &__content
  {
    font-family: "Din Pro";
    font-size: 240px;
    font-weight: 500;
    color: #fff;
  }

  &__link
  {
    a
    {
      margin-top: 20%;
      font-family: "DIN Pro";
      font-size:16px;
      color:#fff;
      opacity: 0.6;
      text-decoration: none;
      transition:0.4s ease;
      cursor: pointer;
      text-align: center;

      &:hover
      {
        opacity:1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/404.vue